import { GRID_SIZES, DEFAULT_GRID_SIZE, DEFAULT_PRODUCTS_PER_PAGE } from '@common/Listing/helpers/constants';

export const getLimitValue = (storeLimit = {}) => {
    const selectedLimit = Object.keys(storeLimit).filter(limitItem => storeLimit[limitItem]);
    const limit = selectedLimit.length > 0
        ? selectedLimit[0]
        : (App.Config.Listing?.paging.productsPerPage || DEFAULT_PRODUCTS_PER_PAGE);
    return Number(limit);
};

export const getGridValue = (gridView) => {
    if (gridView !== null) {
        return GRID_SIZES[gridView] ?? DEFAULT_GRID_SIZE;
    }

    return App.Config.Listing?.gridDefault;
};
